<template>
  <main>
    <not-found-component/>
  </main>
  <push-notification-component/>
  <footer>
    <footer-component/>
  </footer>
</template>

<script>
import FooterComponent from '@/components/Home/Layout/FooterComponent.vue';
import PushNotificationComponent
  from '@/components/Home/Shared/PushNotifications/PushNotificationComponent.vue';
import NotFoundComponent from '@/components/global/NotFoundComponent.vue';

export default {
  name: 'NotFoundView.vue',
  components: {
    NotFoundComponent,
    PushNotificationComponent,
    FooterComponent,
  },
};
</script>
